import { createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit';
import { layoutUpdateActions } from 'redux/layout-update/layout-update.slice';
import { GadgetEditModel } from 'types/entity';
import { areDifferentShallowList } from 'utils/diff-object';
import { gadgetsAdaptor } from './gadget-update.adapter';

export const GADGET_UPDATE_STORE_NAME = 'gadgetUpdate';

export type GadgetUpdateState = EntityState<GadgetEditModel> & {
  selectedId: string
  loaded: boolean
  touched: boolean
  error?: any
}

export const initialGadgetUpdateState: GadgetUpdateState = gadgetsAdaptor.getInitialState({
  selectedId: '',
  loaded: false,
  touched: false,
  error: null,
});

export const gadgetUpdateSlice = createSlice({
  name: GADGET_UPDATE_STORE_NAME,
  initialState: initialGadgetUpdateState,
  reducers: {
    upsert: (state, action: PayloadAction<GadgetEditModel>) => {
      gadgetsAdaptor.upsertOne(state, action.payload);
      state.touched = true;
    },
    upsertMany: (state, action: PayloadAction<GadgetEditModel[]>) => {
      // 前回の値から変更があったら編集中とみなす
      const diffList = action.payload.map((newest) => {
        const old = gadgetsAdaptor.getSelectors().selectById(state, newest.gadget_id || '');
        return [old, newest] as [GadgetEditModel, GadgetEditModel];
      });
      state.touched = state.touched || areDifferentShallowList(diffList);

      gadgetsAdaptor.upsertMany(state, action.payload);
    },
    removeMany: (state, action: PayloadAction<string[]>) => {
      state.touched = state.touched || !!action.payload.length;
      gadgetsAdaptor.removeMany(state, action.payload);
    },
    selectOne: (state, action: PayloadAction<string>) => {
      state.selectedId = action.payload;
    },
    unTouched: (state) => {
      state.touched = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(layoutUpdateActions.clear, (state, _action) => {
      state.touched = false;
      state.selectedId = '';
      state.error = null;
    });
    builder.addCase(layoutUpdateActions.loadLayouts.fulfilled, (state, action) => {
      gadgetsAdaptor.upsertMany(state, action.payload.gadget || {});
    });
    builder.addCase(layoutUpdateActions.saveLayout.fulfilled, (state, _action) => {
      state.touched = false;
    });
  },
});

export const gadgetUpdateActions = {
  ...gadgetUpdateSlice.actions,
};

export default gadgetUpdateSlice.reducer;
